import * as React from 'react'

const IconReactivate = (props) => (
  <svg
    width={24}
    height={24}
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <defs>
      <path id='icon-sm-reactivate_svg__a' d='M0 0h20v9.556H0z' />
      <path id='icon-sm-reactivate_svg__c' d='M0 0h20v9.556H0z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(2 2)'>
        <mask id='icon-sm-reactivate_svg__b' fill='#fff'>
          <use xlinkHref='#icon-sm-reactivate_svg__a' />
        </mask>
        <path
          d='M19.94 6.903a9.557 9.557 0 0 0-5.3-6.077c-4.352-1.94-9.388-.344-11.907 3.53a1.51 1.51 0 0 0-2.696 1.22l.63 2.8A1.512 1.512 0 0 0 2.47 9.518l2.95-.662A1.512 1.512 0 0 0 6.563 7.05a1.512 1.512 0 0 0-1.229-1.157c1.747-2.571 5.142-3.611 8.076-2.306a6.542 6.542 0 0 1 3.626 4.159 1.512 1.512 0 0 0 2.902-.843'
          fill='#00B2E3'
          mask='url(#icon-sm-reactivate_svg__b)'
        />
      </g>
      <g transform='translate(2 12.444)'>
        <mask id='icon-sm-reactivate_svg__d' fill='#fff'>
          <use xlinkHref='#icon-sm-reactivate_svg__c' />
        </mask>
        <path
          d='M.06 2.653a9.557 9.557 0 0 0 5.3 6.077c4.351 1.939 9.387.344 11.906-3.531a1.51 1.51 0 0 0 2.696-1.219l-.629-2.8A1.512 1.512 0 0 0 17.528.038L14.58.7a1.512 1.512 0 0 0-1.144 1.806 1.512 1.512 0 0 0 1.23 1.157c-1.748 2.571-5.143 3.611-8.077 2.306A6.542 6.542 0 0 1 2.962 1.81a1.512 1.512 0 0 0-2.902.843'
          fill='#00B2E3'
          mask='url(#icon-sm-reactivate_svg__d)'
        />
      </g>
    </g>
  </svg>
)

export default IconReactivate
